import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OwnProps } from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuotesDataView } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Check from "@insite/mobius/Icons/Check";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ArrowRightLongIcon from "@tCentro/Icons/ArrowRightLongIcon";
import { COLORS } from "@tCentro/theme/design";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

enum fields {}
const mapStateToProps = (state: ApplicationState) => {
    return {
        quotesDataView: getQuotesDataView(state, recentQuotesParameter),
        myQuotesUrl: getPageLinkByPageType(state, "RfqMyQuotesPage"),
    };
};
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface CENMyAccountMessageStyles {
    container?: InjectableCss;
    linkContainerStyles?: InjectableCss;
    checkStyles?: IconPresentationProps;
    arrowRightIconStyles?: IconPresentationProps;
    messageStyle?: InjectableCss;
    linkStyle?: InjectableCss;
    checkContainerStyles?: InjectableCss;
}

export const cenMyAccountMessageStyles: CENMyAccountMessageStyles = {
    checkContainerStyles: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    messageStyle: {
        css: css`
            color: ${getProp("theme.typography.p.color")};
            font-family: Poppins;
            font-size: 18px;
            font-weight: 400;
            line-height: 28px;
            margin-left: 6.5px;
        `,
    },
    arrowRightIconStyles: {
        css: css`
            svg {
                width: 18px !important;
                height: 11.25px !important;
                > path {
                    fill: ${getColor("text.link")};
                }
            }
        `,
    },
    checkStyles: {
        size: 32,
        css: css`
            svg {
                color: ${getColor("primary")};
            }
        `,
    },
    container: {
        css: css`
            background: rgba(60, 168, 101, 0.08);
            border-left: 8px solid ${getColor("primary")};
            padding: 18px 0px 18px 18px;
            display: flex;
            align-items: center;
            width: 100%;
            flex-wrap: wrap;
        `,
    },
    linkContainerStyles: {
        css: css`
            display: flex;
            gap: 2px;
            align-items: center;
            margin-left: 8px;
        `,
    },
    linkStyle: {
        css: css`
            font-family: Poppins;
            font-size: 18px;
            font-weight: 600;
            line-height: 28px;
            color: ${getColor("text.link")};
        `,
    },
};

const recentQuotesParameter = {
    page: 1,
    pageSize: 5,
};
const styles = cenMyAccountMessageStyles;

const CENMyAccountMessage: FC<Props> = ({ contentId, quotesDataView, myQuotesUrl }) => {
    if (quotesDataView?.value?.length === 0) {
        return null;
    }
    return (
        <>
            {quotesDataView && quotesDataView?.value?.length && quotesDataView?.value?.length > 0 && (
                <StyledWrapper {...styles.container}>
                    <StyledWrapper {...styles.checkContainerStyles}>
                        <Icon src={Check} {...styles.checkStyles} />
                        <Typography {...styles.messageStyle}>
                            {quotesDataView?.value?.length} {siteMessage("MyAccountQuoteMessage")}
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.linkContainerStyles}>
                        <Link href={myQuotesUrl?.url} {...styles.linkStyle}>
                            {translate("Review quotes")}
                        </Link>
                        <Icon src={ArrowRightLongIcon} {...styles.arrowRightIconStyles} />
                    </StyledWrapper>
                </StyledWrapper>
            )}
        </>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(CENMyAccountMessage),
    definition: {
        group: "Common",
        displayName: "CEN My Account Message",
    },
};
export default widgetModule;
